import React, { Component } from 'react';

class IndeterminateProgress extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { ...props } = this.props
        return (
            <div class="indeterminate-progress-slider" {...props}>
                <div class="indeterminate-progress-line"></div>
                <div class="indeterminate-progress-subline indeterminate-progress-inc"></div>
                <div class="indeterminate-progress-subline indeterminate-progress-dec"></div>
            </div>
        );
    }
}

export default IndeterminateProgress;